import React from 'react';

const DataTableWrapper = ({ children, loading, currentPage, setCurrentPage, totalCount, totalPages, rowsPerPage }) => {
    return (
        <>
            <div className="table-responsive border rounded-3">
                {loading ? (
                    <table className="table table-bordered align-middle text-center mb-0" style={{ fontSize: 13 }}>
                        <thead>
                            <tr>
                                {[...Array(10)].map((_, i) => (
                                    <th key={i} className="py-3 px-2">
                                        <div className="placeholder-glow"><span className="placeholder col-12 rounded bg-secondary"></span></div>
                                    </th>
                                ))}
                            </tr>
                            <tr>
                                {[...Array(10)].map((_, i) => (
                                    <th key={i} className="py-2 px-2 bg-light">
                                        <div className="placeholder-glow"><span className="placeholder col-12 rounded bg-secondary" style={{ opacity: 0.6 }}></span></div>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {[...Array(8)].map((_, rowIndex) => (
                                <tr key={rowIndex}>
                                    {[...Array(10)].map((_, colIndex) => (
                                        <td key={colIndex} className="py-3 px-2">
                                            <div className="placeholder-glow"><span className="placeholder col-12 rounded bg-secondary" style={{ opacity: 0.3 }}></span></div>
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                    children
                )}
            </div>

            {/* Database Table Pagination Controls */}
            {(() => {
                if (totalPages <= 1) return null;

                return (
                    <div className="d-flex justify-content-between align-items-center mt-1 flex-wrap gap-2">
                        <span className="text-secondary" style={{ fontSize: 13 }}>
                            Showing <strong className="text-body">{(currentPage - 1) * rowsPerPage + 1}</strong> to <strong className="text-body">{Math.min(currentPage * rowsPerPage, totalCount)}</strong> of <strong className="text-body">{totalCount}</strong> reports
                        </span>

                        <nav aria-label="Page navigation">
                            <ul className="pagination pagination-sm mb-0">
                                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => setCurrentPage(currentPage - 1)}
                                        disabled={currentPage === 1}
                                    >
                                        ◀ Prev
                                    </button>
                                </li>
                                {Array.from({ length: Math.min(5, totalPages) }).map((_, i) => {
                                    let pageNumber = i + 1;
                                    if (currentPage > 3 && totalPages > 5) {
                                        pageNumber = currentPage - 3 + i;
                                        if (pageNumber + (4 - i) > totalPages) {
                                            pageNumber = totalPages - 4 + i;
                                        }
                                    }
                                    return (
                                        <li key={pageNumber} className={`page-item ${currentPage === pageNumber ? 'active' : ''}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => setCurrentPage(pageNumber)}
                                            >
                                                {pageNumber}
                                            </button>
                                        </li>
                                    );
                                })}
                                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => setCurrentPage(currentPage + 1)}
                                        disabled={currentPage === totalPages}
                                    >
                                        Next ▶
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                );
            })()}
        </>
    );
};

export default DataTableWrapper;
